<template>
  <div>
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :value="value"
        class="col-md-12 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.profileNames"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectProfileName',
  props: ['value', 'title', 'profileCategory'],
  data() {
    return {
      selects: {
        simple: '',
        profileNames: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  watch: {
    profileCategory: {
      handler(newValue, oldValue) {
        this.fetchData();
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/profiles/profilefromcategory/${this.profileCategory}`,
        )
        .then(response => {
          this.selects.profileNames = response.data.map(entity => ({
            value: entity.profileId,
            label: entity.profileName,
          }));
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
